import React from 'react';

import {Box, Skeleton, Stack, Paper, Typography} from 'views/components';
import {Person as PersonIcon} from 'views/icons';
import {Translate} from 'views/module';

const TileSkeleton = () => {
  return (
    <Paper sx={{p: 2, borderRadius: 4, minHeight: 140}}>
      <Stack spacing={1}>
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
          <PersonIcon sx={{width: 24, height: 24, color: '#b0b0b0'}} />
          <Typography variant="h6" fontWeight={700}>
            <Translate expression='schedule.eventDetail.UserSection.Client.Title' />
          </Typography>
        </Box>
        <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
          {<Skeleton variant="circular" width={60} height={60} />}
          <Stack>
            <Skeleton variant="text" width={120} height={20} />
            <Skeleton variant="text" width={120} height={18.6} />
            <Skeleton variant="text" width={140} height={14} />
          </Stack>
        </Box>
      </Stack>
    </Paper>
  );
};

export default TileSkeleton;
